module.exports = __webpack_public_path__ + "img/cover6.9347dc4e.jpg";